import { TEventData } from "../@types/data/event"
import { TShoppingTicket } from "../@types/data/ticket"
import { generateTicketID } from "./qrcode"

/** Converte a resposta de `Api.get.purchaseInfo` nos tickets usados pelo PDF. */
export const parsePurchaseTickets = (
  purchase: any,
  event: TEventData,
  orderId: string,
): TShoppingTicket[] => {
  const products = (purchase.products ?? []) as any[]
  const buyerName = purchase.buyer?.name || purchase.buyer_name

  return products.map((t) => ({
    id: t.id,
    opuid: t.opuid,
    name: t.name,
    batch_name: t.batch_name,
    is_mesa: t.is_mesa === true,
    event_name: event.name,
    qr_data: t.qr_data,
    qr_label: t.qr_label,
    combo_id: t.combo_id,
    combo_name: t.combo_name,
    qr_TID: generateTicketID(
      false,
      "ecommerce",
      t.opuid,
      event.oid as number,
      event.dbName as string,
    ),
    order_id: orderId,
    date: new Date(t.date).toISOString(),
    image: null,
    quantity: t.quantity,
    price_unit: t.price_unit,
    tax_value: t.tax_value,
    ticket_name: t.ticket_name,
    user_name: t.user_name,
    buyer_name: buyerName,
    TRN: purchase.extref,
    payment_type: t.payment_type,
    coupon_code: purchase.coupon_code ?? null,
    discount: t.discount,
  })) as unknown as TShoppingTicket[]
}
